import Events from "./views/Events";
import AppLayout from "../../components/AppLayout";
import EventView from "./components/EventView";
import Booking from "./components/Booking/Booking";
import Billing from "./components/Billing";
import Invoice from "./components/Invoice";
import Receipt from "./components/Receipt";
import DelegateCard from "./components/Booking/DelegateCard";

export default [
  {
    path: "/events",
    component: AppLayout,
    children: [
      {
        path: "",
        name: "EventList",
        components: {
          view: Events,
        },
      },
      {
        path: ":no",
        name: "EventCard",
        components: {
          view: EventView,
        },
      },
      {
        path: "booking/:no",
        name: "booking",
        components: {
          view: Booking,
        },
      },
      {
        path: "delegate-card/:no/:id?",
        name: "DelegateCard",
        components: {
          view: Booking,
          action: DelegateCard,
        },
      },
      {
        path: "billing/:bookingNo",
        name: "billing",
        components: {
          view: Billing,
        },
      },
      {
        path: "invoice/:bookingNo/:posted?",
        name: "invoice",
        components: {
          view: Invoice,
        },
      },
      {
        path: "receipt/:receiptNo",
        name: "receipt",
        components: {
          view: Receipt,
        },
      },
      {
        path: "booking-view/:bookingNo",
        name: "BookingView",
        components: {
          view: Booking,
        },
      },
    ],
  },
];
